import { defineStore } from 'pinia'

export const userFilterStore = defineStore('filter', {
	state: () => ({
		options: {
			isopen: false,
			isavailable: false
		}
	}),
	actions: {

	}
	// getters
	// actions
})